export async function loadAdvancedMarkerLibrary() {
    if (google.maps.importLibrary) {
        await google.maps.importLibrary('marker')
    }
}

export async function loadAdvancedMarkerLibraryForMap() {
    await loadAdvancedMarkerLibrary()
}

function normalisePosition(position) {
    return position instanceof google.maps.LatLng
        ? position
        : new google.maps.LatLng(position)
}

function isValidPosition(position) {
    if (!position) {
        return false
    }

    const lat = typeof position.lat === 'function' ? position.lat() : position.lat
    const lng = typeof position.lng === 'function' ? position.lng() : position.lng

    return Number.isFinite(lat) && Number.isFinite(lng)
}

export function createOverlayMarker({ position, content, map = null, title = '', zIndex = 0 }) {
    class OverlayMarker extends google.maps.OverlayView {
        constructor() {
            super()
            this.position = normalisePosition(position)
            this.content = content
            this.visible = true
            this.zIndex = zIndex
            this.div = document.createElement('button')
            this.div.type = 'button'
            this.div.title = title
            this.div.style.background = 'transparent'
            this.div.style.border = '0'
            this.div.style.cursor = 'pointer'
            this.div.style.padding = '0'
            this.div.style.position = 'absolute'
            this.div.style.transform = 'translate(-50%, -50%)'
            this.div.style.zIndex = String(zIndex)
            this.div.appendChild(content)
            this.setMap(map)
        }

        addListener(eventName, listener) {
            this.div.addEventListener(eventName, listener)

            return {
                remove: () => this.div.removeEventListener(eventName, listener)
            }
        }

        getPosition() {
            return this.position
        }

        getVisible() {
            return true
        }

        onAdd() {
            const panes = this.getPanes()

            if (panes && panes.overlayMouseTarget) {
                panes.overlayMouseTarget.appendChild(this.div)
            }
        }

        draw() {
            if (!this.getMap() || !this.div.parentNode || !isValidPosition(this.position)) {
                return
            }

            let projection = null

            try {
                projection = this.getProjection()
            } catch (error) {
                return
            }

            if (!projection) {
                return
            }

            const point = projection.fromLatLngToDivPixel(this.position)

            if (!point) {
                return
            }

            this.div.style.display = this.visible ? '' : 'none'
            this.div.style.left = `${point.x}px`
            this.div.style.top = `${point.y}px`
        }

        onRemove() {
            this.visible = false
            this.div.style.display = 'none'

            if (this.div.parentNode) {
                this.div.parentNode.removeChild(this.div)
            }
        }

        setVisible(visible) {
            this.visible = visible
            this.div.style.display = visible ? '' : 'none'
        }
    }

    return new OverlayMarker()
}

export function createAdvancedIconMarker({ position, icon, map = null, title = '' }) {
    const markerContent = document.createElement('img')
    markerContent.src = icon
    markerContent.alt = title

    return createOverlayMarker({
        position,
        content: markerContent,
        map,
        title
    })
}

export function createMapIconMarker({ position, icon, map = null, mapObject = null, title = '' }) {
    return createAdvancedIconMarker({
        position,
        icon,
        map: map || mapObject,
        title
    })
}

export function addMapMarkerClickListener(marker, listener) {
    marker.addListener('click', listener)
}

export function getAdvancedMarkerMapOptions(mapOptions) {
    return mapOptions
}

export function removeMarker(marker) {
    setMarkerMap(marker, null)
}

export function setMarkerVisible(marker, visible, map = null) {
    if (marker.setVisible) {
        marker.setVisible(visible)
    }

    if (marker.content) {
        marker.content.style.display = visible ? '' : 'none'
    }

    setMarkerMap(marker, visible ? map : null)
}

export function setMarkerMap(marker, map) {
    if (marker.setMap) {
        marker.setMap(map)
        return
    }

    marker.map = map
}
